import { MemCommonEditorStore } from "@/components/note/store/MemCommonEditorStore";
import { AnimationTiming } from "@/design-system/constants/common";
import { MDSTooltip, MDSTooltipPlacement, MDSTooltipTrigger } from "@/mds";
import styled from "@emotion/styled";
import { observer } from "mobx-react-lite";
import { MouseEventHandler } from "react";

interface NoteEditorMetadataProps {
  onClick: MouseEventHandler<HTMLDivElement>;
  store: MemCommonEditorStore;
  className?: string;
}

export const NoteEditorMetadata = observer<NoteEditorMetadataProps>(function NoteEditorMetadata({
  className,
  onClick,
  store,
}) {
  return (
    <StyledWrapper>
      <MDSTooltip
        config={{
          label: store.metadataTooltip,
          placement: MDSTooltipPlacement.TopLeft,
          delaySeconds: AnimationTiming.TooltipHoverDelaySeconds,
        }}
      >
        <MDSTooltipTrigger>
          <Metadata onClick={onClick} className={className}>
            {store.metadata}
          </Metadata>
        </MDSTooltipTrigger>
      </MDSTooltip>
    </StyledWrapper>
  );
});

const Metadata = styled.span`
  color: ${({ theme }) => theme.colors.text.editor.metadata};
  font-size: ${({ theme }) => theme.fontSizes.xxsmall};
  line-height: ${({ theme }) => theme.lineHeights.small};
`;

const StyledWrapper = styled.div`
  padding-left: var(--extra-padding-left);
`;
